var _class, _Legends;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import PropTypes from "prop-types";
import { PureComponent } from "react";
import { scaleOrdinal } from "@visx/scale";
import { LegendOrdinal } from "@visx/legend";
import Glyphs from "./Glyphs";
import { GlyphCircle } from "@visx/glyph";
import { TextSpan } from "../../../Styled/Text";
import styled from "styled-components";
import { observer } from "mobx-react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
let Legends = observer(_class = (_Legends = class Legends extends PureComponent {
  render() {
    const chartItems = this.props.chartItems;
    const colorScale = scaleOrdinal({
      domain: chartItems.map(c => "".concat(c.categoryName, " ").concat(c.name)),
      range: chartItems.map(c => c.getColor())
    });
    return /*#__PURE__*/_jsx(LegendsContainer, {
      style: {
        maxWidth: this.props.width
      },
      children: /*#__PURE__*/_jsx(LegendOrdinal, {
        scale: colorScale,
        children: labels => labels.map((label, i) => {
          var _chartItems$i$glyphSt, _chartItems$i;
          return /*#__PURE__*/_jsx(Legend, {
            label: label,
            glyph: (_chartItems$i$glyphSt = (_chartItems$i = chartItems[i]) === null || _chartItems$i === void 0 ? void 0 : _chartItems$i.glyphStyle) !== null && _chartItems$i$glyphSt !== void 0 ? _chartItems$i$glyphSt : "circle"
          }, "legend-".concat(label.text));
        })
      })
    });
  }
}, _defineProperty(_Legends, "propTypes", {
  chartItems: PropTypes.array.isRequired,
  width: PropTypes.number.isRequired
}), _defineProperty(_Legends, "maxHeightPx", 33), _Legends)) || _class;
export default Legends;
class Legend extends PureComponent {
  render() {
    var _Glyphs$this$props$gl;
    const label = this.props.label;
    const squareSize = 20;
    const Glyph = (_Glyphs$this$props$gl = Glyphs[this.props.glyph]) !== null && _Glyphs$this$props$gl !== void 0 ? _Glyphs$this$props$gl : GlyphCircle;
    return /*#__PURE__*/_jsxs(LegendWrapper, {
      title: label.text,
      "aria-label": label.text,
      children: [/*#__PURE__*/_jsx("svg", {
        width: "".concat(squareSize, "px"),
        height: "".concat(squareSize, "px"),
        style: {
          flexShrink: 0
        },
        children: /*#__PURE__*/_jsx(Glyph, {
          top: 10,
          left: 10,
          fill: label.value,
          size: 100
        })
      }), /*#__PURE__*/_jsx(LegendText, {
        children: label.text
      })]
    });
  }
}
_defineProperty(Legend, "propTypes", {
  label: PropTypes.object.isRequired,
  glyph: PropTypes.string
});
const LegendsContainer = styled.div.withConfig({
  displayName: "Legends__LegendsContainer",
  componentId: "sc-dyza7a-0"
})(["display:flex;flex-direction:row;justify-content:center;margin:auto;padding:7px;font-size:0.8em;"]);
const LegendWrapper = styled.div.withConfig({
  displayName: "Legends__LegendWrapper",
  componentId: "sc-dyza7a-1"
})(["display:flex;flex:1;align-items:center;justify-content:center;min-width:0px;"]);
const LegendText = styled(TextSpan).attrs({
  noWrap: true,
  overflowEllipsis: true,
  overflowHide: true,
  medium: true
}).withConfig({
  displayName: "Legends__LegendText",
  componentId: "sc-dyza7a-2"
})(["margin-left:4px;"]);